export default __webpack_public_path__ + "static/media/11-100.3f855d53.jpg";